import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../shared/loading/loading.service';

@Component({
  selector: 'bxb-footer',
  template: require('./bxb-footer.component.html'),
  styles: [require('./bxb-footer.component.scss'), require('../shared/styles/form.scss')]
})
export class BXBFooterComponent implements OnInit {

  public currentYear: number;
  constructor(private loadingService: LoadingService) {
    // Do stuff
  }

  ngOnInit() {
    console.log('bxb footer');
    let d = new Date();
    this.currentYear = d.getFullYear();
    this.loadingService.hideLoading();
  }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/bxb-footer/bxb-footer.component.ts